<template>
    <div>
        <b-modal
            ref="modalExportarExtratoBancario"
            size="lg"
            no-close-on-esc
            no-close-on-backdrop
            scrollable
            id="modal-exportar-extrato"
            title="Exportar extrato bancário"
            @hide="fecharModal"
            >

                <el-form v-loading="loadingForm" class="geral-form" ref="formExportarExtratoBancario" :model="model" :rules="rules" size="small" label-position="top">
                    <el-row :gutter="20">
                        <el-col :span="14">
                            <el-form-item label="Data início/Fim" prop="inicioFim" required>
                                <el-date-picker
                                    v-model="model.inicioFim"
                                    type="daterange"
                                    range-separator="|"
                                    start-placeholder="De"
                                    end-placeholder="Até"
                                    align="right"
                                    format="dd/MM/yyyy"
                                    size="small"
                                    class="w-100">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="Status" prop="status">
                                <el-select
                                    v-model="model.status"
                                    placeholder="Selecione o status"
                                    class="w-100"
                                    >
                                    <el-option
                                        v-for="item in listas.status"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        
                        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                            <el-form-item label="Grupo" prop="cliente" v-loading="loadGrupos" required>
                                <el-select class="w-100" size="small" v-model="model.cliente" filterable clearable :placeholder="`Selecione um grupo`">
                                    <el-option
                                    v-for="item in listaGrupos"
                                    :key="item.id"
                                    :label="item.label"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                            <el-form-item label="Empresas" prop="empresas" v-loading="loadEmpresas">
                                <el-select class="w-100" size="small" v-model="model.empresas" filterable multiple collapse-tags clearable :disabled="habilitaEmpresaConta" :placeholder="`Selecione uma empresa`">
                                    <el-option
                                    v-for="item in listaEmpresas"
                                    :key="item.id"
                                    :label="item.label"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                            <el-form-item label="Conta" prop="conta" v-loading="loadConta" required>
                                <el-select class="w-100" size="small" v-model="model.conta" filterable multiple collapse-tags clearable :disabled="habilitaEmpresaConta" :placeholder="`Selecione uma conta`">
                                    <el-option
                                    v-for="item in listaContas"
                                    :key="item.id"
                                    :label="item.label"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">  

                        <el-col :span="10">
                            <el-form-item label="Modo de exibição" prop="modoExibicao">
                                <el-select
                                    v-model="model.modoExibicao"
                                    placeholder="Selecione o status"
                                    class="w-100"
                                    >
                                    <el-option
                                        v-for="item in listas.modoExibicao"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>
                
                <template #modal-footer="{ hide }">
                    <div class="float-right">
                        <el-button size="small" @click="hide()">Fechar</el-button>
                        <el-button size="small" icon="el-icon-download" type="primary" @click="exportar" :loading="loadingForm">Exportar</el-button> 
                    </div>
                </template>
            </b-modal>
    </div>
</template>
<script>
const model = () => {
    return {
        cliente: '',
        empresas: [],
        conta: [],
        inicioFim: [],
        status: 0,
        modoExibicao: 0
    }
}

export default {
    name: 'ModalExportarExtratoBancario',
    props: {
        loadGrupos: {
            type: Boolean,
            required: false
        },
        listaGrupos: {
            type: Array,
            required: false
        }
    },
    data() {
        return {
            model: model(),
            loadingForm: false,
            loadEmpresas: false,
            loadConta: false,
            listaEmpresas: [],
            listaContas: [],
            listas: {
                status: [
                    {
                        value: 0,
                        label: 'Todos'
                    },{
                        value: 1,
                        label: 'Conciliados'
                    }, {
                        value: 2,
                        label: 'Não Conciliados'
                    },
                ],
                modoExibicao: [
                    {
                        value: 0,
                        label: 'Sintético'
                    },{
                        value: 1,
                        label: 'Analítico'
                    }
                ],
            },
            rules: {
                cliente: [
                    { required: true, message: 'Por favor, escolha um grupo', trigger: ['change','blur'] }
                ],
                conta: [
                    { required: true, message: 'Por favor, escolha uma conta', trigger: ['change','blur'] }
                ],
                inicioFim: [
                    { type: 'array', required: true, message: 'Por favor, escolha um range de datas', trigger: 'change' }
                ]
			},
        }
    },
    methods: {
        // requests
        exportar() {
            const ctx = this

            ctx.$refs['formExportarExtratoBancario'].validate((valid) => {
                if (!valid) {
					ctx.$notify.error({
						title: 'Validação',
						message: `Por favor, preencha todos os campos obrigatórios`,
						position:'top-left'
					});
					return
				}

                ctx.getExportarExtrato()
            });
        },
        async getExportarExtrato() {
            this.loadingForm = true;

            const params = {
                clienteId: this.model.cliente,
                ContasIds: this.model.conta.join(','),
                ModoDeExibicao: this.model.modoExibicao,
                Inicio: this.model.inicioFim[0],
                Fim: this.model.inicioFim[1],
            }
            if(this.model.status === 1 || this.model.status === 2) {
                params.Conciliado = this.model.status === 1 ? true : false 
            }

            try {

                const response = await this.axios.post(this.$urls.EXPORTAR_EXTRATO, params);

                this.$notify({
                    type: "success",
                    title: 'Gerando Relatório',
                    dangerouslyUseHTMLString: true,
                    message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
                });

                console.log('response: ',response)
            } catch (error) {
                console.error('Erro ao pesquisar extrato:', error);
            } finally {
                this.loadingForm = false;
            }
        },
        async getContas(idCliente, idEmpresas) { // clientes
            this.loadConta = true

            const idsEmp = idEmpresas ? `&empresasIds=${idEmpresas}` : ''

            try {
                const response = await this.axios.get(`${this.$urls.CONTAS}?clienteId=${idCliente}${idsEmp}`)
                
                if(response.status !== 200) {
                    throw new Error('Erro ao carregar lista de Contas')
                }

                this.listaContas = response.data
            } catch(err) {
                console.error(err)
            } finally {
                this.loadConta = false
            }
        },
        async getEmpresas(idCliente) { // clientes
            this.loadEmpresas = true

            try {
                const response = await this.axios.get(`${this.$urls.EMPRESAS_POR_CLIENTE}?clienteId=${idCliente}`)
                
                if(response.status !== 200) {
                    throw new Error('Erro ao carregar lista de Empresas')
                }

                this.listaEmpresas = response.data
            } catch(err) {
                console.error(err)
            } finally {
                this.loadEmpresas = false
            }
        },
        fecharModal() {
            this.model = model();
            this.$refs['formExportarExtratoBancario'].clearValidate();
        },
    },
    computed: {
        habilitaEmpresaConta() {
            return !this.model.cliente
        }
    },
    watch: {
        'model.cliente'(id) {
            this.model.conta = []
            this.model.empresas = []
            this.$refs['formExportarExtratoBancario'].clearValidate();
            if(id) {
                this.getEmpresas(id)
                this.getContas(id)
            }
        },
        'model.empresas'(id) {
            this.model.conta = []
            this.$refs['formExportarExtratoBancario'].clearValidate();
            if(id.length) {
                this.getContas(this.model.cliente, id.join(','))
            }
        }
    },
};
</script>
<style lang='scss' scoped>
.header-filter {
    padding: 1px 10px 2px 10px;
    .icon-close-filter {
        margin:3px;
    }
}
.box-filtro-info {
    border: 2px solid #c1c5c2;
    border-radius: 5px;
    padding: 0px 10px 2px;
    background: #e7e7e7;
}
.btn-filtros-a {
    margin-left: 5px;
}
#filtroEmpresas {
    padding: 21px !important;
}
</style>